import React, { useEffect, useState } from "react";
import { Container, MainText, AdditionalText, Line, InfoContainer, InfoTitle, ButtonWrapper, MainButton } from "./MainStyle";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // 스타일 임포트
import { Carousel } from "react-responsive-carousel"; // Carousel 컴포넌트 임포트
import { Link } from "react-router-dom";
import { Button } from 'react-bootstrap'

function Main() {
  const [showMainText, setShowMainText] = useState(true);
  const [showAdditionalText, setShowAdditionalText] = useState(false);
  const [scrollDirection, setScrollDirection] = useState("down");

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;

      if (scrollY >= windowHeight / 3) {
        if (scrollDirection !== "up") {
          setShowMainText(false);
          setShowAdditionalText(true);
          setScrollDirection("up");
        }
      } else {
        if (scrollDirection !== "down") {
          setShowMainText(true);
          setShowAdditionalText(false);
          setScrollDirection("down");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [scrollDirection]);

  return (
    <Container>
      <Button variant="light"
        style={{
          position: 'absolute', top: 0, right: 0, fontWeight: "700", fontSize: "0.8rem",
          margin: '10px', color: "#66CDAA", backgroudn: "white"
        }}>
        <Link to="/eng" style={{textDecoration:"none", color:"#66CDAA"}}>   
            Change English version
        </Link> 
      </Button>
      <MainText visible={showMainText}>Hello, Ssook's World!</MainText>
      <Line />
      <AdditionalText visible={showAdditionalText}>'쑥'스럽게</AdditionalText>
      {showAdditionalText && (
        <InfoContainer>
          <InfoTitle>About Me_</InfoTitle>
          <Carousel showThumbs={false} showStatus={false} infiniteLoop autoPlay showIndicators={false} style={{ marginBottom: "100px" }}>
            <div style={{ width: "100%" }}>
              <ButtonWrapper>
                <Link to="/resume">
                  <MainButton>
                    <h4 style={{ fontWeight: 'bold' }}>Resume</h4>
                    <hr style={{ backgroundColor: '#66CDAA', height: '1px', border: '0', fontWeight: 'border' }} />
                    <p style={{ fontWeight: 'lighter', fontSize: '1rem' }}>
                      학력, 이력 등 딱딱한 이야기 뿐만 아니라, <br></br>
                      가치관이나 MBTI 등 조금은 <b>진솔하고, 또 가벼운 소개</b>들도 <br></br>
                      이 곳에서 확인하실 수 있습니다. <br />
                    </p>
                  </MainButton>
                </Link>
              </ButtonWrapper>
            </div>
            <div>
              <ButtonWrapper>
                <Link to="/personality">
                  <MainButton>
                    <h4 style={{ fontWeight: 'bold' }}>Personality</h4>
                    <hr style={{ backgroundColor: '#66CDAA', height: '1px', border: '0', fontWeight: 'border' }} />
                    <p style={{ fontWeight: 'lighter', fontSize: '1rem' }}>
                      제 성격에 대한 조금 더 상세한 이야기들을 담고 있습니다. <br></br>
                      특히 주변 사람들이 말하는 저는 <b>'어떤 사람'</b>인지, <br></br>
                      이에 대한 평을 조금 더 자세히 들어볼 수 있습니다.
                    </p>
                  </MainButton>
                </Link>
              </ButtonWrapper>
            </div>
            <div style={{ marginBottom: "3%" }}>
              <ButtonWrapper>
                <Link to="/project">
                  <MainButton>
                    <h4 style={{ fontWeight: 'bold' }}>Project & TechStack</h4>
                    <hr style={{ backgroundColor: '#66CDAA', height: '1px', border: '0' }} />
                    <p style={{ fontWeight: 'lighter', fontSize: '1rem' }}>
                      <b>저의 이력서에 적혀 있는 프로젝트는 극히 일부</b>입니다. <br></br>
                      직무에 맞게 프로젝트에서 수행한 내용을 뽑아서 적기 때문입니다. <br></br>
                      마케팅부터, 데이터 분석, 기획, 개발, 서비스 운영까지. 한 번에 확인해보세요!<br></br>
                    </p>
                  </MainButton>
                </Link>
              </ButtonWrapper>
            </div>
            <div>
              <ButtonWrapper>
                <Link to="/award">
                  <MainButton>
                    <h4 style={{ fontWeight: 'bold' }}>Award & Certificate</h4>
                    <hr style={{ backgroundColor: '#66CDAA', height: '1px', border: '0' }} />
                    <p style={{ fontWeight: 'lighter', fontSize: '1rem' }}>
                      <b>저의 이력서에 적혀 있는 수상경력</b>도 역시 <b>극히 일부</b>입니다. <br></br>
                      직무에 맞게 일부만 뽑아서 적기 때문입니다. <br></br>
                      기획, 개발, 국회의원 상까지. 다양한 분야에서 수상한 저의 경력을 확인해보세요!<br></br>
                    </p>
                  </MainButton>
                </Link>
              </ButtonWrapper>
            </div>
          </Carousel>
        </InfoContainer>
      )}
    </Container>
  );
}

export default Main;
